import styled from 'styled-components'
import { type HeaderData } from '@/features/cms/components/CMS/types'
import { LogoOnlyHeader } from '@/features/shared/components/Headers/LogoOnlyHeader'
import { UngatedHeaderContent } from '@/features/shared/components/Headers/UngatedHeader/UngatedHeaderContent'
import { getCMSWrapperProps } from '@/features/cms/components/CMS/utils/getCMSWrapperProps'
import { GlobalAnimatedHeader } from '@/features/shared/components/Headers/GlobalHeader/GlobalAnimatedHeader'

/**
 * This component corresponds to the `header` content type in the CMS.
 *
 * - **Staging** - https://cms-staging.shipt.com/content-type/pool/header
 * - **Production** - https://cms.shipt.com/content-type/pool/header
 */
export const CMSHeader = ({
  content_type_id,
  id,
  data: { header_type, is_sticky },
}: HeaderData) => {
  switch (header_type) {
    case 'global':
      return <GlobalAnimatedHeader excludeSubheader />
    case 'logo_only':
    case 'transparent':
      return (
        <Wrapper
          data-header-type={header_type}
          data-is-sticky={is_sticky}
          {...getCMSWrapperProps({ content_type_id, id })}
        >
          <LogoOnlyHeader />
        </Wrapper>
      )
    default:
      return (
        <Wrapper
          data-header-type={header_type}
          data-is-sticky={is_sticky}
          {...getCMSWrapperProps({ content_type_id, id })}
        >
          <UngatedHeaderContent />
        </Wrapper>
      )
  }
}

const Wrapper = styled.header<{
  'data-header-type': HeaderData['data']['header_type']
  'data-is-sticky': boolean
}>`
  background: white;
  box-shadow: 0 0.125rem 0.625rem 0 rgb(0 0 0 / 10%);

  &[data-header-type='transparent'] {
    background: transparent;
    margin-bottom: -5rem;
    box-shadow: none;
  }

  &[data-header-type='logo_only'] {
    position: relative;
  }

  &[data-is-sticky='true'] {
    position: sticky;
    top: 0;
    z-index: 999;
  }
`
